import { createContext } from 'react';

const DataTableContext = createContext({});

export default DataTableContext;
